import {getState} from '@shopify/theme-cart';

export interface CartLinkElement extends HTMLElement {
  cartlink?: CartLink;
}

export interface CartLinkOptions {
  updatedClass: string;
  liveClass: string;
  duration: number;
  countEl: string;
  selector: string;
}

type Options = Partial<CartLinkOptions>;

export class CartLink {
  static defaults: CartLinkOptions = {
    countEl: '[data-cartlink-count]',
    duration: 1000,
    liveClass: 'has-items',
    selector: '[data-cartlink]',
    updatedClass: 'has-updated',
  };
  element: CartLinkElement;
  count: HTMLElement;
  options: CartLinkOptions;
  updateHandler: EventListener;

  constructor(element: CartLinkElement, opts: Options = {}) {
    if (!element || element.cartlink) {
      return;
    }

    element.cartlink = this;
    this.element = element;
    this.options = {
      ...CartLink.defaults,
      ...this.element.dataset,
      ...opts,
    };

    this.options.duration = Number(this.options.duration);

    const count = this.element.querySelector(
      this.options.countEl,
    ) as HTMLElement;

    if (!count) {
      return;
    }

    this.count = count;

    this.bind();
  }

  bind() {
    this.updateHandler = this.handleCartUpdated.bind(this);
    document.documentElement.addEventListener(
      'cart:updated',
      this.updateHandler,
    );
  }

  handleCartUpdated() {
    getState()
      .then(this.updateCount.bind(this))
      .then(this.runDecorator.bind(this))
      .catch();
  }

  updateCount(result: Cart) {
    this.count.innerText = result.item_count.toString(10);
    result.item_count > 0 ? this.toggleLive(true) : this.toggleLive(false);

    return result;
  }

  toggleLive(state: boolean) {
    this.element.classList.toggle(this.options.liveClass, state);
  }

  runDecorator() {
    this.element.classList.add(this.options.updatedClass);

    window.setTimeout(
      () => this.element.classList.remove(this.options.updatedClass),
      this.options.duration,
    );
  }

  destroy() {
    document.documentElement.removeEventListener(
      'cart:updated',
      this.updateHandler,
    );
    this.element.cartlink = undefined;
  }
}
